import React from "react";

import Paper from "@material-ui/core/Paper";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Skeleton from "@material-ui/lab/Skeleton";

import { makeStyles } from "@material-ui/core/styles";
import { green, red } from '@material-ui/core/colors';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import moment from 'moment';

import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
	on: {
		color: green[600],
		fontSize: '20px'
	},
	off: {
		color: red[600],
		fontSize: '20px'
	},
    pointer: {
        cursor: "pointer"
    }
}));

// Nota média de 0 a 10 da tela Avaliações, com uma casa decimal (sem cortar
// para baixo, como fazia a antiga coluna de estrelas).
export function RatingScore ({ rating, count }) {
    if (rating === null || rating === undefined) return "—";
    const value = Number(rating).toLocaleString(i18n.language || "pt-BR", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
    });
    return (
        <span>
            <strong>{value}</strong>
            <span style={{ opacity: 0.7, fontSize: 12 }}>
                {" "}{i18n.t("ticketRatings.dashboardColumn.count", { total: count })}
            </span>
        </span>
    );
}

export default function TableAttendantsStatus(props) {
    const { loading, attendants } = props
	const classes = useStyles();

    function renderList () {
        return attendants.map((a, k) => (
            <TableRow key={k}>
                <TableCell>{a.name}</TableCell>
                <TableCell align="center" title={i18n.t("ticketRatings.dashboardColumn.hint")} className={classes.pointer}>
                    <RatingScore rating={a.rating} count={a.ratingCount} />
                </TableCell>
                <TableCell align="center">{formatTime(a.avgSupportTime, 2)}</TableCell>
                <TableCell align="center">
                    { a.online ?
                        <CheckCircleIcon className={classes.on} />
                        : <ErrorIcon className={classes.off} />
                    }
                </TableCell>
            </TableRow>
        ))
    }

	function formatTime(minutes){
		return moment().startOf('day').add(minutes, 'minutes').format('HH[h] mm[m]');
	}

    return ( !loading ?
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{i18n.t("common.name")}</TableCell>
                        <TableCell align="center">{i18n.t("ticketRatings.dashboardColumn.title")}</TableCell>
                        <TableCell align="center">{i18n.t("dashboard.attendantsTable.avgSupportTime")}</TableCell>
                        <TableCell align="center">{i18n.t("dashboard.attendantsTable.currentStatus")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    { renderList() }
                    {/* <TableRow>
                        <TableCell>Nome 4</TableCell>
                        <TableCell align="center">10</TableCell>
                        <TableCell align="center">10 minutos</TableCell>
                        <TableCell align="center">
                            <CheckCircleIcon className={classes.off} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Nome 5</TableCell>
                        <TableCell align="center">10</TableCell>
                        <TableCell align="center">10 minutos</TableCell>
                        <TableCell align="center">
                            <CheckCircleIcon className={classes.on} />
                        </TableCell>
                    </TableRow> */}
                </TableBody>
            </Table>
        </TableContainer>
        : <Skeleton variant="rect" height={150} />
    )
}